import { useState, useEffect } from 'react';
import { Form, Upload, message } from 'antd';
import { Langs } from '@/components';
import { useUpdate } from '@/hooks';
import styles from '@/pages/AppCreate/ApplicationCreate.module.less';
import { RcFile } from 'antd/lib/upload';
import { UPLOAD_WIDTH, UPLOAD_HEIGHT } from '@/config';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { APP_LIST_TYPE } from '@/service/apps/type/appList.d';
import { useTranslation } from 'react-i18next';

type UploadType = {
  form?: any;
  name: 'logo' | 'logo_reverse';
  label?: React.ReactNode;
  rules?: Record<string, any>[];
  uploadFile: (info: any, type: string) => void;
  appInfo?: APP_LIST_TYPE;
  logoRef?: any;
  help?: React.ReactNode;
  render?: React.ReactNode;
  tipText?: React.ReactNode;
  size?: string;
};

const LogoMap = {
  logo: 'TYPE_SETTING',
  logo_reverse: 'TYPE_TOPBAR',
};

export const AppUpload = ({
  form,
  name,
  rules,
  label,
  uploadFile,
  appInfo,
  logoRef,
  help,
  render,
  size,
}: UploadType) => {
  const [loading, setLoading] = useState(false);
  const [update] = useUpdate();
  const { t } = useTranslation();

  useEffect(() => {
    window.EVENT.on('UPLOAD_ERROR', () => {
      setLoading(false);
    });
    window.EVENT.on('UPLOAD_SUCCESS', () => {
      setLoading(false);
    });
  }, []);

  const beforeUpload = (file: RcFile, type: string): any => {
    setLoading(true);
    return new Promise((resolve, reject) => {
      const _URL = window.URL || window.webkitURL;
      const image = new Image();
      image.src = _URL.createObjectURL(file);
      image.onload = function () {
        if (file.size / 1024 / 1024 > 1) {
          message.error(t('develop_prefix_tit_create_one_30'));
          return;
        }
        if (localStorage.getItem('WEB_DEVELOP_TEST')) {
          resolve('error');
          return;
        }
        resolve('');
        // if (type === 'logo') {
        //   if (image.width === UPLOAD_WIDTH && image.height === UPLOAD_WIDTH) {
        //     resolve('error');
        //   } else {
        //     message.error(<Langs title="app_tip_3" />);
        //     setLoading(false);
        //     reject('error');
        //   }
        // }
        // if (type === 'logo_reverse') {
        //   if (image.width === UPLOAD_HEIGHT && image.height === UPLOAD_WIDTH) {
        //     resolve('');
        //   } else {
        //     message.error('Please upload a 540px * 144px reverse logo file in PNG format');
        //     setLoading(false);
        //     reject('error');
        //   }
        // }
      };
    });
  };

  const onChange = (info: any) => {
    console.log(logoRef);
    form.setFieldsValue({
      [name]: logoRef[name] as any,
    });
    update();
  };

  const uploadIcon = () => {
    if (loading) {
      return <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />;
    }
    const iconUrl = 'https://img.dsers.com/global/icon-add.png';
    // const iconUrl = 'https://img.dsers.com/global/addicon.png';
    const imgLogoUrl = appInfo?.logos!.find((items) => items.type == LogoMap[name])?.url || '';
    return (
      <div className={styles.uploadBtn}>
        {form.getFieldValue(name) ? (
          typeof form.getFieldValue(name) !== 'object' ? (
            <img src={form.getFieldValue(name)} />
          ) : (
            // <img src={iconUrl} style={{ width: '36px' }} />
            <PlusOutlined className={styles.add} />
          )
        ) : imgLogoUrl !== '' ? (
          <img
            src={imgLogoUrl}
            style={imgLogoUrl.indexOf(iconUrl) === 0 ? { width: '36px', height: '36px' } : {}}
          />
        ) : (
          <>
            <PlusOutlined className={styles.add} />
            <div style={{ color: 'rgba(0, 0, 0, 0.50)' }}>{size}</div>
          </>
        )}
      </div>
    );
  };

  const errorDom = () => {
    return <div style={{ fontSize: 14 }}>{help}</div>;
  };

  return (
    <>
      <Form.Item name={name} label={label} rules={rules}>
        {errorDom()}
        <Upload
          onChange={onChange}
          customRequest={(info) => {
            uploadFile(info, name);
          }}
          accept="image/gif, image/jpeg, image/png"
          beforeUpload={(file) => beforeUpload(file, name)}
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          fileList={[]}
          style={{ overflow: 'hidden', width: '300px' }}
        >
          {uploadIcon()}
          {render}
        </Upload>
      </Form.Item>
    </>
  );
};
